import { render, staticRenderFns } from "./RecordImageRows.vue?vue&type=template&id=2f355d18"
import script from "./RecordImageRows.vue?vue&type=script&lang=js"
export * from "./RecordImageRows.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../frontAgencies/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports